/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:  2022-01-11 14:47:45
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import empty from 'src/assets/images/filter-tree/empty-option.png';

class NoSearchResult extends Component<WithI18nProps> {
  render() {
    const { i18n } = this.props;

    return (
      <div className="BC-EmptyOption__Translation">
        <img src={empty} alt="Empty" />
        <p>{i18n.translate('AdminHTML.Translation.NoSearchResult.noItem')} </p>
        <p style={{ marginTop: '0.625rem' }}>
          <TextStyle variation="subdued">
            {i18n.translate('AdminHTML.Translation.NoSearchResult.noItemSub')}
          </TextStyle>
        </p>
      </div>
    );
  }
}

export default withI18n()(NoSearchResult);
